import React from 'react';
import UserLayout from '../../components/layouts/UserLayout';
import ProfileForm from "../../components/combinations/ProfileForm";
import styled from "styled-components";
import LinkText from "../../components/parts/LinkText";
import { api } from '../../../api';
import { useNavigate } from "react-router";
import Divider from "../../components/parts/Divider";
import UserHead from "../../config/UserHead";

const ProfileStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    padding: 0 0 20px 0;
    margin: 30px 10px;
  }
`;

const ToPasswordResetPageStyle = styled(LinkText)`
  text-align: center;
  text-decoration: underline;
`;

const LogoutStyle = styled.p`
  cursor: pointer;
  text-align: center;
  text-decoration: underline;
  
  &:hover {
    color: #676969;
  }
`;

const Profile: React.FC = (() => {
  const navigate = useNavigate();
  const onClickLogout = () => {
    api.userLogout().then(() => navigate('/'));
  };

  return (
    <UserLayout>
      <UserHead title='プロフィール' />
      <ProfileStyle>
        <ProfileForm />
        <ToPasswordResetPageStyle href='/user/password-reset-reception'>パスワードの更新はこちら</ToPasswordResetPageStyle>
        <Divider mt='20px' mb='20px' />
        <LogoutStyle onClick={onClickLogout}>ログアウト</LogoutStyle>
      </ProfileStyle>
    </UserLayout>
  );
});
export default Profile;
